import axios from "axios";
import { Client } from "./types";
import { getValidToken } from "../../../utils/authUtils";

export const clientApi = {
  getClients: async () => {
    try {
      const url = `${process.env.REACT_APP_API_HOST}master-data/clients`;
      const token = await getValidToken();
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess && response?.data?.data?.length > 0) {
        return response.data.data;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  },
  addEditClient: async (client: Client, isEdit: boolean) => {
    try {
      const url = isEdit
        ? `${process.env.REACT_APP_API_HOST}master-data/clients/${client.id}`
        : `${process.env.REACT_APP_API_HOST}master-data/clients`;
      const token = await getValidToken();
      const response = await axios[isEdit ? "put" : "post"](url, client, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response?.data?.isSuccess) {
        return true;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error) {
      throw error;
    }
  },
};
